"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = exports.MessageStatusEnum = exports.MessageTransportEnum = exports.MessageTemplateEnum = void 0;
/**
 * Типы уведомлений
 */
var MessageTemplateEnum;
(function (MessageTemplateEnum) {
  /** приветствие нового пользователя */
  MessageTemplateEnum["welcome"] = "welcome";
  /** подтверждение email */
  MessageTemplateEnum["confirm_email"] = "confirm_email";
  /** подтверждение смены email */
  MessageTemplateEnum["confirm_email_change"] = "confirm_email_change";
  /** подтверждение email */
  MessageTemplateEnum["password_changed"] = "password_changed";
  /** подтверждение email */
  MessageTemplateEnum["password_generated"] = "password_generated";
  MessageTemplateEnum["confirm_reset_password"] = "confirm_reset_password";
  /** восстановление пароля */
  MessageTemplateEnum["restore_password"] = "restore_password";
  /** подтверждение телефона */
  MessageTemplateEnum["confirm_phone"] = "confirm_phone";
  MessageTemplateEnum["confirm_phone_change"] = "confirm_phone_change";
  /** новый комментарий */
  MessageTemplateEnum["new_comment"] = "new_comment";
  /** новый лайк */
  MessageTemplateEnum["new_like"] = "new_like";
  /** новый подписчик */
  MessageTemplateEnum["new_subscriber"] = "new_subscriber";
  /** запрос на митинг */
  MessageTemplateEnum["request_meeting"] = "request_meeting";
  /** запрос на митинг подтвержlён */
  MessageTemplateEnum["confirm_meeting"] = "confirm_meeting";
  /** запрос на митинг отклонен */
  MessageTemplateEnum["reject_meeting"] = "reject_meeting";
  /** напоминание о митинге */
  MessageTemplateEnum["remind_meeting"] = "remind_meeting";
  /** кто-то присоединился к митингу */
  MessageTemplateEnum["join_meeting"] = "join_meeting";
  /** кто-то покинул митинг */
  MessageTemplateEnum["leave_meeting"] = "leave_meeting";
  /** изменение расписания */
  MessageTemplateEnum["update_schedule"] = "update_schedule";
  /** изменение статуса митинга */
  MessageTemplateEnum["update_meeting_status"] = "update_meeting_status";
  /** приглашение */
  MessageTemplateEnum["invite_to_meeting"] = "invite_to_meeting";
  /** обновление митинга */
  MessageTemplateEnum["update_meeting"] = "update_meeting";
  /**
   * Вместо этого сообщения, доставляемого через HTTP, используется уведомление, доставляемое через RabbitMQ
   *
   * @see NotificationsQueueService.entityUpdated({ entity: 'balance', ... })
   *
   * @deprecated
   */
  MessageTemplateEnum["update_balance"] = "update_balance";
  MessageTemplateEnum["update_operation"] = "update_operation";
  MessageTemplateEnum["update_account"] = "update_account";
})(MessageTemplateEnum = exports.MessageTemplateEnum || (exports.MessageTemplateEnum = {}));
/**
 * Способы доставки уведомлений
 */
var MessageTransportEnum;
(function (MessageTransportEnum) {
  MessageTransportEnum["all"] = "*";
  MessageTransportEnum["sms"] = "sms";
  MessageTransportEnum["email"] = "email";
  /** сообщения через сервис https://pushall.ru/ */
  MessageTransportEnum["pushall"] = "pushall";
  /** сообщения  через сокет-сервер https://ws.onclass.com */
  MessageTransportEnum["ws"] = "ws";
  /** пуши через центр уведомлений Apple */
  MessageTransportEnum["apple_push"] = "apple_push";
  /** пуши через Firebase (Google Android, Google Chrome, ...) */
  MessageTransportEnum["firebase"] = "firebase";
  /** пуши через центр уведомлений Microsoft */
  MessageTransportEnum["azure_push"] = "azure_push";
  /** Собщения через Telegram */
  MessageTransportEnum["telegram"] = "telegram";
  /** Собщения через Viber */
  MessageTransportEnum["viber"] = "viber";
  /** Собщения через What's Up */
  MessageTransportEnum["whatsup"] = "whatsup";
})(MessageTransportEnum = exports.MessageTransportEnum || (exports.MessageTransportEnum = {}));
/**
 * Статус сообщения
 */
var MessageStatusEnum;
(function (MessageStatusEnum) {
  MessageStatusEnum[MessageStatusEnum["error"] = 0] = "error";
  /** в процессе отправки */
  MessageStatusEnum[MessageStatusEnum["pending"] = 1] = "pending";
  /** повтор отправки */
  MessageStatusEnum[MessageStatusEnum["retrying"] = 2] = "retrying";
  /** отправлено */
  MessageStatusEnum[MessageStatusEnum["sent"] = 3] = "sent";
  /** доставлено */
  MessageStatusEnum[MessageStatusEnum["delivered"] = 4] = "delivered";
  /** прочитано */
  MessageStatusEnum[MessageStatusEnum["read"] = 5] = "read";
})(MessageStatusEnum = exports.MessageStatusEnum || (exports.MessageStatusEnum = {}));
/** Общие интерфейсы */
/**
 * Структура одного уведомления
 */
var Message = /** @class */function () {
  function Message() {}
  return Message;
}();
exports.Message = Message;
// export interface IInviteMeetingParams {
//   meeting_id: string;
//   author_name: string;
//   title: string;
//   description: string;
//   begin_at: Date;
//   end_at: Date;
//   url: string;
//   // TODO аватарка преподавателя
//   // TODO обложка митинга
// }
